


































































































































































































import {Vue, Component, Emit, Prop} from 'vue-property-decorator'
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {mixins} from "vue-class-component";


@Component({})
export default class ObjektiCard1 extends mixins(ComponentBaseMixin) {
  @Prop() chains!: [];
  @Prop() users!: [];
  @Prop() storeCategories!: [];
  @Prop() storeTypes!: [];
  @Prop() suppliers!: [];
  @Prop() racks!: [];

  map: any = '';
  markers: any = [];

  advancedSearch = {
    pib: '', name: '', companyName: '', address: '', city: '',
    categoryId: '', supplierId: '', storeTypeId: '',
    fromDate: '', toDate: '', supplyChain: '',
    responsible: '', rack: ''
  };
  isBusyAdvSearch = false;
  stores = [];
  storeColumns = [];

  tableOptions = {
    pagination: true,
    sortable: true,
    onClickRow: (row) => this.onClickRow(row)
  };


  async created() {
    this.storeColumns = [
      {field: 'name', sortable: true, title: this.$i18n.t('naziv')},
      {field: 'address', sortable: true, title: this.$i18n.t('adresa')},
      {field: 'city', sortable: true, title: this.$i18n.t('mesto')}
    ];
  }

  async mounted() {
    $('#daterange').daterangepicker(
        {format: this.$i18n.t('DATE_FORMAT')}
    ).on('apply.daterangepicker', (ev, picker) => {
      this.advancedSearch.fromDate = picker.startDate.format('YYYY-MM-DD');
      this.advancedSearch.toDate = picker.endDate.format('YYYY-MM-DD');
    });
  }

  async naprednaPretraga() {
    try {
      this.isBusyAdvSearch = true;
      const results = await this.axios.get('api/SearchStores', {
        params: {
          pib: this.advancedSearch.pib,
          companyName: this.advancedSearch.companyName,
          name: this.advancedSearch.name,
          address: this.advancedSearch.address,
          city: this.advancedSearch.city,
          categoryId: this.advancedSearch.categoryId,
          supplierId: this.advancedSearch.supplierId,
          storeTypeId: this.advancedSearch.storeTypeId,
          fromDate: this.advancedSearch.fromDate,
          toDate: this.advancedSearch.toDate,
          supplyChain: this.advancedSearch.supplyChain,
          responsible: this.advancedSearch.responsible,
          rack: this.advancedSearch.rack
        }
      });
      this.stores = results.data;
      if (results.data.length > 0) {
        const pretragaTab = $('#pretraga-tab');
        pretragaTab.attr('aria-selected', 'false');
        pretragaTab.removeClass('active');
        $('#pretraga').removeClass('active show');

        const rezultatiTab = $('#rezultati-tab');
        rezultatiTab.attr('aria-selected', 'true');
        rezultatiTab.addClass('active');
        $('#rezultati').addClass('active show');

        const table = $('#resultTable');
        table.bootstrapTable('refresh');
        table.on('refresh.bs.table', function () {
          table.bootstrapTable('selectPage', 1);
        });
      }
    } catch (e) {
      this.isBusyAdvSearch = false;
      this.showError('greskaPrilikomUcitavanja');
    } finally {
      this.isBusyAdvSearch = false;
    }
  }

  ponistiPretragu() {
    this.advancedSearch = {
      pib: '', name: '', companyName: '', address: '', city: '',
      categoryId: '', supplierId: '', storeTypeId: '',
      fromDate: '', toDate: '', supplyChain: '',
      responsible: '', rack: ''
    };
  }

  excelExport() {
    let url = 'api/stores/export?';
    url += (`pib=${this.advancedSearch.pib || ''}`);
    url += (`&name=${this.advancedSearch.name || ''}`);
    url += (`&address=${this.advancedSearch.address || ''}`);
    url += (`&city=${this.advancedSearch.city || ''}`);
    url += (`&categoryId=${this.advancedSearch.categoryId || ''}`);
    url += (`&supplierId=${this.advancedSearch.supplierId || ''}`);
    url += (`&storeTypeId=${this.advancedSearch.storeTypeId || ''}`);
    url += (`&fromDate=${this.advancedSearch.fromDate || ''}`);
    url += (`&toDate=${this.advancedSearch.toDate || ''}`);
    url += (`&supplyChain=${this.advancedSearch.supplyChain || ''}`);
    url += (`&responsible=${this.advancedSearch.responsible || ''}`);
    window.open(url, "_blank");
  }

  @Emit() onClickRow(row) {
  }

}
